/* unplugin-vue-components disabled */import script from "./editHelp.vue?vue&type=script&lang=ts&setup=true"
export * from "./editHelp.vue?vue&type=script&lang=ts&setup=true"

import "./editHelp.vue?vue&type=style&index=0&id=0db5f323&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db5f323"]])

export default __exports__